import { PbxHttpClient } from "@/services/httpclient";

const state = {
  allQueue: [],
  status_queue_extension: "",
};

const getters = {
  GET_QUEUES(state) {
    return state.allQueue;
  },
  GET_STATUS_QUEUES(state) {
    return state.status_queue_extension;
  },
};

const mutations = {
  SET_ALL_QUEUE(state, payload) {
    state.allQueue = payload;
  },

  PUSH_QUEUE: (state, payload) => {
    const value = state.allQueue.find((element) => {
      return element.id === payload.id;
    });
    if (value === undefined) {
      state.allQueue.push(payload);
    }
  },

  UPDATE_QUEUE: (state, payload) => {
    const indexupdate = state.allQueue
      .map((element) => {
        return element.id;
      })
      .indexOf(payload.id);
    if (indexupdate > -1) {
      state.allQueue.splice(indexupdate, 1, payload);
    }
  },

  DELETE_QUEUE: (state, payload) => {
    const indexdelete = state.allQueue
      .map((element) => {
        return element.id;
      })
      .indexOf(payload);
    if (indexdelete > -1) {
      state.allQueue.splice(indexdelete, 1);
    }
  },

  STATUS_QUEUE: (state, payload) => {
    localStorage.setItem("extension_queue", payload.extension);
    state.status_queue_extension = payload.extension;
  },
};

const actions = {
  async GET_QUEUES({ commit }, isRestrictedSupervisor = false) {
    try {
      const response = isRestrictedSupervisor
        ? await PbxHttpClient.get("/clients/queues")
        : await PbxHttpClient.get("/showQueue");

      const list = response.data.data;
      commit("SET_ALL_QUEUE", list);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async QUEUE_SOCKET() {
    try {
      const response = await PbxHttpClient.get("/manager/queue");
      // commit("SET_ALL_QUEUE", response.data.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async REGISTER_QUEUE({ commit }, payload) {
    try {
      const response = await PbxHttpClient.post("/clients/queues", payload);
      commit("PUSH_QUEUE", response.data.cola);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async SHOW_QUEUE({ commit }) {
    try {
      const response = await PbxHttpClient.get("/clients/queues");
      commit("SET_ALL_QUEUE", response.data.data);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async EDIT_QUEUE({ commit }, payload) {
    try {
      const response = await PbxHttpClient.put(`/clients/queues/${payload.id}`, payload.data);
      commit("UPDATE_QUEUE", response.data.cola);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },

  async DELETE_QUEUE({ commit }, payload) {
    try {
      const response = await PbxHttpClient.delete(`/clients/queues/${payload.id}`);
      commit("DELETE_QUEUE", payload.id);
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

// Exportar Clientes
export const queue = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
